import React from 'react';
import getInjuryStatusColor from '../../utils/getInjuryStatusColor';
import { normalizeStatusBucket, statusBucketLabel } from '../../utils/injuryStatus';

export default function InjuryReportStatusPill({ status, injuryDescription }) {
	if (!status) return <span className="text-gray-400">—</span>;

	const bucket = normalizeStatusBucket(status);
	const label = bucket ? statusBucketLabel(bucket) : status;
	const color = getInjuryStatusColor(status);

	return (
		<div className="flex min-w-0 flex-col gap-0.5">
			<div className="inline-flex items-center gap-1.5">
				<span
					className="h-2 w-2 flex-shrink-0 rounded-full"
					style={{ backgroundColor: color }}
					aria-hidden
				/>
				<span className="text-sm font-medium text-gray-800 dark:text-dark-text">{label}</span>
			</div>
			{injuryDescription && (
				<span className="pl-3.5 text-xs text-gray-500 dark:text-gray-400 truncate">
					{injuryDescription}
				</span>
			)}
		</div>
	);
}
